import React from "react";
import "./InfoCard.css";
import { Link } from "react-router-dom";
import imgRightArrow from "../../images/icons/DRight_Arrow.png";

const InfoCard = (props) => {
  const getLinkPath = () => {
    switch (props.title) {
      case "စုစုပေါင်း ကုန်သည်":
        return "/member";
      case "စုစုပေါင်း ကယ်ရီ":
        return "/product";
      case "စုစုပေါင်း ရောင်းပြီး ကုန်စည်":
        return "/lot";
      default:
        return "/dashboard";
    }
  };
  return (
    <Link to={getLinkPath()} className="info-card">
      <div className="d-flex flex-row gap-3 align-items-start">
      <img src={props.icon} width={props.iconWidth} className="icon" alt="" />

      <div className="title_text card_title m-0">{props.title}</div>

        <div className="count">{props.count}</div>
        <div className="sale">{props.sale}</div>
      </div>

      <div className="d-flex justify-content-start">
        <button type="button" className="btnSeeMore">
          <div className="text">See More</div>
          <img
            src={imgRightArrow}
            alt="right-arrow"
            className="imgRightArrow"
          />
        </button>
      </div>
    </Link>
  );
};

export default InfoCard;
